import React, { useContext, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { GlobalContext } from './../../GlobalState';
import { logChatPromiseExecution } from 'stream-chat';
import { MessageList, MessageInput, Window, useChannelActionContext, useChatContext } from 'stream-chat-react';
import { PrimeChannelHeader, TeamChannelHeader, DirectChannelHeader } from '../ChannelHeaders';

export const ChannelInner = () => {
  const { globalState, setGlobalState } = useContext(GlobalContext);
  const { sendMessage, jumpToMessage } = useChannelActionContext();
  const { channel } = useChatContext();
  const [contextMenu, setContextMenu] = useState(null);
  useEffect(() => {
    if (Object.keys(globalState.jumpTo).length > 0 && globalState.jumpTo.ch_id === channel.id && globalState.jumpTo.ch_type === channel.type) {
      jumpToMessage(globalState.jumpTo.msg_id, 1000);
      setGlobalState.setJumpTo({});
    }
  });
  const handleContextMenu = (e) => {
    let curSelectedText = document.getSelection().toString();
    if (typeof channel.data.unitCode === 'string' && channel.data.unitCode !== '' && e.target.nodeName === 'P' && curSelectedText.length > 0) {
      e.preventDefault();
      setContextMenu( contextMenu === null ? { mouseX: e.clientX + 2, mouseY: e.clientY - 6, } : null);
    };
  };
  const handleContextMenuClose = ({type, unit, text}) => { 
    if (type === 'copy' && text.length > 0) handleContextMenuCopy(text);
    if (type === 'unit' && unit.length > 0 && text.length > 0) window.open(`${globalState.app_config.backEnv}/vehicles?searchUnit=${encodeURIComponent(unit)}&openVehicleStatus=true&zip=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer')
    setContextMenu(null);
  };
  const handleContextMenuCopy = async (text) => {
    if ('clipboard' in navigator) return await navigator.clipboard.writeText(text);
    else return document.execCommand('copy', true, text);
  };
  const overrideSubmitHandler = (message) => {
    let updatedMessage = {
      attachments: message.attachments,
      mentioned_users: message.mentioned_users,
      parent_id: message.parent?.id,
      parent: message.parent,
      text: message.text,
    };
    if (sendMessage) {
      const sendMessagePromise = sendMessage(updatedMessage);
      logChatPromiseExecution(sendMessagePromise, 'send message');
    }
  };
  const parsedUnitCodes = (typeof channel.data.unitCode === 'string' && channel.data.unitCode !== '') ? channel.data.unitCode.split(' ').sort((a, b) => {
    if (a.toLowerCase().startsWith(globalState.search.input.toLowerCase()) === true && b.toLowerCase().startsWith(globalState.search.input.toLowerCase()) === false) return -1;
    else if (a.toLowerCase().startsWith(globalState.search.input.toLowerCase()) === false && b.toLowerCase().startsWith(globalState.search.input.toLowerCase()) === true) return 1;
    else return 0;
  }).sort((a, b) => {
    if (a.toLocaleLowerCase() < b.toLocaleLowerCase()) return -1;
    if (a.toLocaleLowerCase() > b.toLocaleLowerCase()) return 1;
    return 0;
  }) : [];
  return (
      <div style={{ display: 'flex', width: '100%' }} onContextMenu={handleContextMenu}>
        <Window>
          { channel.type === 'prime' && <PrimeChannelHeader /> }
          { channel.type === 'team' && <TeamChannelHeader /> }
          { channel.type === 'direct' && <DirectChannelHeader /> }
          <MessageList 
            returnAllReadData={true}
            messageActions={channel.type === 'prime' ? [] : ['quote', 'react'] }
            noGroupByUser={false}
            renderText={(text, mentionedusers) => {
              text = text.replace(/\n-|^-/g, '\n&#45;');
              text = text.replace(/\n\+|^\+/g, '\n&#43;');
              text = text.replace(/\*/g, '&#42;');
              text = text.replace(/_/g, '&#95;');
              text = text.replace(/~/g, '&#126;');
              text = text.replace(/\t/g, '');
              text = text.split('\n').map(item => /^[0-9]+\..+/g.test(item) === true ? item.replace(/\./g, '&#46;') : item).join('\n');
              text = text.split('\n').map(item => /^#$|^#\s.+/g.test(item) === true ? item.replace(/#/g, '&#35;') : item).join('\n');
              text = text.split('\n').map(item => /^>$|^>\s.+/g.test(item) === true ? item.replace(/>/g, '&#62;') : item).join('\n');
              return <ReactMarkdown linkTarget='_blank' children={text} remarkPlugins={[remarkGfm]}/>;
            }
            }
            unsafeHTML={false}
            // disableQuotedMessages={false}
            // onlySenderCanEdit={true}
          />
          { channel.data.frozen === false && <MessageInput grow overrideSubmitHandler={overrideSubmitHandler} disableMentions={true} mentionAllAppUsers={false} disabled={false} /> }
          { channel.type === 'prime' && <Menu
            open={contextMenu !== null}
            onClose={handleContextMenuClose}
            anchorReference='anchorPosition'
            anchorPosition={ contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined }
            PaperProps={{ style: { maxHeight: 280 } }}
          >
            <MenuItem onClick={() => handleContextMenuClose({type: 'copy', text: document.getSelection().toString()})} key='copy'>Copy</MenuItem>
            { parsedUnitCodes.map((unit, index) => <MenuItem onClick={() => handleContextMenuClose({type: 'unit', unit: unit, text: document.getSelection().toString()})} key={channel.cid+unit+index}>{`Update ${unit} status`}</MenuItem>) }
          </Menu> }
        </Window>
      </div>
  );
};
